export const generateFormNumber = (list: any[], formField: any) => {
  const regex = /^\d{2}\.\d{2}\.[A-Z]\d{2}$/;

  const values = list.map((item) => String(item?.[formField] ?? '').trim()).filter(Boolean);

  const structedValues = values.filter((v) => regex.test(v));

  if (structedValues.length > 0) {
    const match = structedValues[0].match(/^(\d{2})\.(\d{2})\.([A-Z])/)!;

    const folder = match[1];
    const incident = match[2];
    const type = match[3];

    const prefix = `${folder}.${incident}.${type}`;

    const set = new Set<number>();

    for (const v of structedValues) {
      const m = v.match(new RegExp(`^${folder}\\.${incident}\\.${type}(\\d{2})$`));

      if (m) set.add(parseInt(m[1], 10));
    }

    let expected = 1;

    while (set.has(expected)) expected++;

    return `${prefix}${String(expected).padStart(2, '0')}`;
  }

  const dot = values.find((v) => /^\d{2}\.\d{2}$/.test(v));

  if (dot) {
    const [major] = dot.split('.');

    const set = new Set<number>();

    for (const v of values) {
      const m = v.match(new RegExp(`^${major}\\.(\\d{2})$`));
      if (m) set.add(parseInt(m[1], 10));
    }

    let expected = 1;

    while (set.has(expected)) expected++;

    return `${major}.${String(expected).padStart(2, '0')}`;
  }

  const set = new Set<number>();

  for (const v of values) {
    if (!Number.isNaN(Number(v))) {
      set.add(parseInt(v, 10));
    }
  }

  let expected = 1;

  while (set.has(expected)) expected++;

  return String(expected).padStart(2, '0');
};
